import { render, staticRenderFns } from "./customerlist.vue?vue&type=template&id=73884af1&scoped=true&"
import script from "./customerlist.vue?vue&type=script&lang=js&"
export * from "./customerlist.vue?vue&type=script&lang=js&"
import style0 from "./customerlist.vue?vue&type=style&index=0&id=73884af1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73884af1",
  null
  
)

export default component.exports